<template>
	<div :class="{ 'nk-multichoice': true, 'nk-mc-editable': settings.editable === true, 'fit-on-content': !settings.wrap }">
		<div class="row no-gutters">
			<div v-if="settings.editable === true" class="col col-auto editor">
				<nk-dropdown :options="settings.dropdown" v-model="dropdownSelectedItem" @update:modelValue="dropdownSelectedItemChanged" :data="dropdownData" :tabindex="tabindex" :startup="startup ? true : null" :small="small" ref="dropdown"></nk-dropdown>
			</div>
			<div v-if="settings.showEmptyLabel && settings.editable !== true && selecteds.length === 0">
				<div class="col col-auto empty">{{ $t('empty-items') }}</div>
			</div>
			<div v-for="(opt, i) in selecteds" :key="i" class="col col-auto selected">
				<div class="tag" tabindex="0" :class="{ 'focused': activeIndex == i }" @click="(e) => tagClicked(e, i)">
					<div v-if="settings.editable === true" class="tag-remove" @click="() => removeTag(opt)">
						<icon icon="trash" />
					</div>
					<div class="tag-content" v-html="settings.display(opt)"></div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import _ from 'lodash'
	import $ from 'jquery'
	import TabOrder from '~/statics/taborder-functions'

	export default {
		props: {
			modelValue: { type: Array },
			data: { type: Array },
			options: { type: Object },
			tabindex: { type: [String, Number] },
			startup: { type: Boolean },
			small: { type: Boolean, default: false }
		},
		emits: ['update:modelValue'],
		watch: {
			modelValue: {
				handler(val, oldVal) {
					this.selecteds = val
					this.defer(() => this.calculateWidth(), 150)
				}
			},
			options: {
				immediate: true,
				deep: true,
				handler(val, oldVal) {
					this.settings = _.merge({}, this.settings, val)
					this.defer(() => this.calculateWidth(), 150)
				}
			},
			'settings.editable': {
				handler(val, oldVal) {
					if (val !== oldVal) {
						this.defer(() => {
							let grandParentType = this.grandParentType()
							TabOrder.subscribeKeys(grandParentType, this)
						}, 500)
					}
				}
			}
		},
		data() {
			return {
				selecteds: [],
				dropdownSelectedItem: null,
				settings: {
					dropdown: {
						searchRequestFilter: this.dropdownSearchRequestFilter
					},
					comparer: (first, second) => first === second,
					display: (item) => item,
					editable: true,
					showEmptyLabel: false,
					wrap: true
				},
				activeIndex: -1
			}
		},
		computed: {
			dropdownData() {
				return this.data
			}
		},
		created() {
			this.selecteds = this.modelValue || []
		},
		mounted() {
			let _vm = this

			$(this.$el).on('blur', () => {
				_vm.activeIndex = -1
			})

			this.defer(() => this.calculateWidth(), 150)
		},
		methods: {
			cloneOptions(options) {
				this.settings = _.extend(this.settings, options)
			},
			clearEditor() {
				this.dropdownSelectedItem = null
			},
			dropdownSelectedItemChanged(val) {
				if (val == null) {
					return
				}

				if (!this.selecteds) {
					this.selecteds = []
				}

				this.selecteds.tryPush(val, this.settings.comparer)
				this.defer(this.clearEditor, 1)

				this.$emit('update:modelValue', this.selecteds)
				this.defer(() => this.$refs.dropdown.clear(), 5)
			},
			dropdownSearchRequestFilter(item, request) {
				if (item != null) {
					if (typeof this.settings.searchRequestFilter === 'function') {
						var res = this.settings.searchRequestFilter(this.selecteds, request)
						request = $.extend(true, {}, request, res)
					}
				}

				return request
			},
			refocusActiveSelected() {
				this.defer(() => $(this.$el).find('.selected .tag.focused').focus(), 1)
			},
			refocusDropdown() {
				this.defer(() => {
					let drp = this.$refs.dropdown
					if (drp != null) {
						$(drp.$el).find('input').focus()
					}
				}, 1)
			},
			tagClicked(e, index) {
				this.activeIndex = index
				e.preventDefault()
				e.stopPropagation()
			},
			removeTag(tag) {
				if (this.settings.editable !== true) {
					return
				}

				if (this.selecteds.tryRemove(tag)) {
					this.$emit('update:modelValue', this.selecteds)

					if (this.selecteds.length > 0 && this.activeIndex > 0) {
						this.activeIndex -= 1
					} else {
						this.refocusDropdown()
					}
				}
			},
			calculateWidth() {
				if (this.settings.wrap !== false) {
					return
				}

				let sum = 0
				let mrg = 0
				let pdg = 0
				for (let col of $(this.$el).find('> .row > .col')) {
					let $col = $(col)
					sum += parseFloat($col.width())
					mrg += parseFloat($col.css('margin-left')) + parseFloat($col.css('margin-right'))
					pdg += parseFloat($col.css('padding-left')) + parseFloat($col.css('padding-right'))
				}

				sum += mrg
				sum += pdg

				if (sum > 0) {
					$(this.$el).width(sum).trigger('resize')
				}
			},

			subscribeKeys() {
				this.$keyHandler.Subscribe({
					name: 'multichoice-nav-left',
					keyCode: [37], // 37:arrow-left
					el: this.$el,
					context: this,
					handler: function (sender, e) {
						if (!this.selecteds || this.selecteds.length === 0) {
							this.activeIndex = -1
							return
						}

						e.preventDefault()

						if (this.activeIndex === -1) {
							this.activeIndex = 0
							this.refocusActiveSelected()
							return true
						} else if (this.activeIndex < this.selecteds.length - 1) {
							this.activeIndex += 1
							this.refocusActiveSelected()
							return true
						} else {
							this.activeIndex = -1
						}
					}
				})
				this.$keyHandler.Subscribe({
					name: 'multichoice-nav-right',
					keyCode: [39], // 39:arrow-right
					el: this.$el,
					context: this,
					handler: function (sender, e) {
						if (!this.selecteds || this.selecteds.length === 0) {
							this.activeIndex = -1
							return
						}

						e.preventDefault()

						if (this.activeIndex === 0) {
							this.activeIndex = -1
							this.refocusDropdown()
							return true
						} else if (this.activeIndex > 0 && this.activeIndex < this.selecteds.length) {
							this.activeIndex -= 1
							this.refocusActiveSelected()
							return true
						} else {
							this.activeIndex = -1
						}
					}
				})
				this.$keyHandler.Subscribe({
					name: 'multichoice-delete',
					keyCode: [8, 46], // 8:backspace 46:delete
					el: this.$el,
					context: this,
					handler: function (sender, e) {
						if (this.activeIndex > -1 && this.activeIndex < this.selecteds.length) {
							let tag = this.selecteds[this.activeIndex]
							this.removeTag(tag)
						}
					}
				})
			}
		}
	}
</script>
<style></style>
